import type { Product } from '../../../data/product';
import { CollapsingProductLabels } from '../../products/collapsing-product-labels';
import { defineColumn, type StrictColumnDef } from '../../tanstack-table/column';

export const ProductNameWithLabels: StrictColumnDef<Product> = defineColumn<Product>({
  id: 'Product',
  minWidth: 350,
  maxWidth: 580,
  accessorFn: (product) => `${product.brand} | ${product.description}`,
  toCSV: (product) => ({
    Brand: product.brand,
    Description: product.description,
  }),
  cell: ({ item: product, value }) => (
    <div className="flex items-center w-full relative overflow-hidden">
      <div className="min-w-0 flex-1 truncate">{value}</div>
      <CollapsingProductLabels labelIds={product.label_ids} />
    </div>
  ),
});
